import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f1d504c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col w-full mt-2" }
const _hoisted_2 = { class: "flex-row w-full" }
const _hoisted_3 = { class: "transition-all pending-message-spinner" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "max-w-[80%] items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerAnimation = _resolveComponent("SpinnerAnimation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-row items-center space-x-2 w-full", [
          _ctx.messageIsFromAgent && 'justify-start',
          _ctx.messageIsFromClient && 'justify-end',
        ]])
      }, [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createVNode(_component_SpinnerAnimation, { class: "w-3 h-3" })
        ], 512), [
          [_vShow, _ctx.isMessagePending]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass([
            _ctx.messageIsFromAgent && `${_ctx.inboundStyleClass}`,
            _ctx.messageIsFromAgent &&
              _ctx.isFromPreviousConversation &&
              'bg-gray-100 text-gray-500',
            _ctx.messageIsFromAgent && !_ctx.isFromPreviousConversation && 'bg-gray-200',
            _ctx.messageIsFromClient && `${_ctx.outboundStyleClass}`,
            _ctx.messageIsFromClient &&
              (_ctx.isFromPreviousConversation || _ctx.isMessagePending) &&
              'opacity-60 pending',
            _ctx.messageIsFromClient &&
              !_ctx.isFromPreviousConversation &&
              !_ctx.isMessagePending &&
              '',
            'px-3 py-2 rounded-lg whitespace-pre-line break-words transition-colors max-w-[80%]',
          ]),
          innerHTML: _ctx.text
        }, null, 10, _hoisted_4)
      ], 2)
    ]),
    (_ctx.hasBottomSlot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "bottom", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}